import { useTranslator } from 'tradera-lang/translate';

export const useCurrencyDisplay = currency => {
    const { t } = useTranslator();
    return currency === 'SEK' ? t('currency_sek') : currency;
};
